<h1 mat-dialog-title>
  {{ ("editShiftTimes" | i18n) || "Dienstzeit anpassen" }}
</h1>
<div
  mat-dialog-content
  (keydown.enter)="close()">
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("shiftStart" | i18n) || "Dienstbeginn" }}</mat-label>
        <input
          matInput
          type="time"
          [name]="'from-' + id"
          [(ngModel)]="from"
          required
          [errorStateMatcher]="timeMatcher"
          placeholder="from"
          data-cy="edit-shift-from-input" />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("shiftEnd" | i18n) || "Dienstende" }}</mat-label>
        <input
          matInput
          type="time"
          [name]="'to-' + id"
          [(ngModel)]="to"
          required
          [errorStateMatcher]="timeMatcher"
          placeholder="to"
          data-cy="edit-shift-to-input" />
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    class="bordered-button"
    type="button"
    mat-button
    (click)="close()"
    data-cy="edit-shift-save-button">
    {{ ("save" | i18n) || "save" }}
  </button>
</div>
